import { ComponentRef } from '@angular/core';

/**
 * Spacers are filling the gap between widgets in the informationview and act as dropzones
 * to drop widgets between other widgets to change the order.
 *
 * This class holds some methods to create, add and remove those spacers.
 */
export class SpacerHelper {

  public static readonly SPACER_CSS_CLASSNAME = 'spacer';
  public static readonly SPACER_DROPZONE_CSS_CLASSNAME = 'sort-dropzone';
  public static readonly SPACER_LAST_CSS_CLASSNAME = 'spacer--last';
  public static readonly SPACER_ACTIVE_CSS_CLASSNAME = 'spacer--active';

  private constructor() { }

  public static getNewSpacerElement(): HTMLElement {
    const spacer = document.createElement('div');
    spacer.classList.add(SpacerHelper.SPACER_CSS_CLASSNAME);

    const dropzone = document.createElement('div');
    dropzone.classList.add(SpacerHelper.SPACER_DROPZONE_CSS_CLASSNAME);
    spacer.appendChild(dropzone);
    return spacer;
  }


  // TODO this could probably be removed by using informationview.updateSpacers() correctly in the right places
  /**
       * Removes the spacer to the left of the widgetWrapper the widgetWrapperRef refers to from the DOM of the widgetcontainer.
       * This only works if both the wrapper and the spacer are actually in the container.
       */
  public static removeLeftSpacerFromDOM(widgetWrapperRef: ComponentRef<any>, widgetContainerId: string): void {
    const previousElement: HTMLElement = widgetWrapperRef.location.nativeElement.previousElementSibling;
    const parent: HTMLElement = previousElement.parentElement;
    // Make sure we have the correct element and related container before we try to remove it
    if (previousElement
      && previousElement.classList.contains(this.SPACER_CSS_CLASSNAME)
      && parent
      && (parent.id === widgetContainerId)) {

      parent.removeChild(previousElement);
    }
  }


}
